<template>
  <div>
    <br />
    <br />

    <div class="modal fade" id="mod-add-role" role="dialog">
      <div
        class="modal-dialog p-0 m-0 fixed overflow-y-scroll top-0 right-0 flex justify-end items-end"
        role="document"
      >
        <div
          class="modal-content h-full md:min-h-screen rounded-none bg-[#f8f8f8] p-[40px]"
        >
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Create New Sales Role
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body p-0 m-0">
            <div>
              <label
                class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Role Name</label
              >
              <div class="mb-[16px] w-full">
                <input
                  :class="[{ 'is-invalid': v1.name }]"
                  type="text"
                  v-model="createRole.name"
                  class="bg-[[#fcfcfd]] border-[##96a0b5] border-solid border-[1.5px] py-[14px] px-[16px] md:px-[24px] rounded-[8px] text-[14px] md:text-[16px] font-medium leading-[20px] w-full"
                  placeholder="Enter role name"
                />
                <ul v-if="v1.name" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>
            <div class="mt-[16px]">
              <div>
                <label
                  class="text-[#353535] font-medium text-[14px] leading-[20px]"
                  >Access Rights</label
                >
                <div
                  class="bg-white w-full"
                  style="height: 320px; overflow-y: scroll"
                >
                  <ol>
                    <li>
                      <div
                        class="flex items-center gap-[5px] py-[14px] px-[10px] border-b border-[#eee]"
                      >
                        <input
                          type="checkbox"
                          name="manager"
                          class="custom-checkbox"
                          v-model="createRole.isManager"
                          @click.stop
                        />
                        <label
                          class="font-normal text-[#353535] text-[16px] m-0 w-full"
                          for="manager"
                        >
                          Manager
                        </label>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6 text-[#353535] transition-transform duration-300 cursor-pointer"
                          :class="{ 'rotate-180': isManagerDropdownOpen }"
                          @click="toggleManagerDropdown"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>

                      <ol v-show="isManagerDropdownOpen">
                        <li>
                          <div
                            class="flex items-center gap-[5px] py-[10px] px-[26px] border-b border-[#eee]"
                          >
                            <input
                              type="checkbox"
                              name="manageDistributorManagers"
                              class="custom-checkbox"
                              v-model="createRole.canManageDistributorManagers"
                            />
                            <label
                              class="font-normal text-[#353535] text-[16px] m-0 w-full"
                              for="manageDistributorManagers"
                              >Manage Distributor Managers</label
                            >
                          </div>
                        </li>
                        <li>
                          <div
                            class="flex items-center gap-[5px] py-[10px] px-[26px] border-b border-[#eee]"
                          >
                            <input
                              type="checkbox"
                              name="manageStateManagers"
                              class="custom-checkbox"
                              v-model="createRole.canManageStateManagers"
                            />
                            <label
                              class="font-normal text-[#353535] text-[16px] m-0 w-full"
                              for="manageStateManagers"
                              >Manage State Managers</label
                            >
                          </div>
                        </li>
                        <li>
                          <div
                            class="flex items-center gap-[5px] py-[10px] px-[26px] border-b border-[#eee]"
                          >
                            <input
                              type="checkbox"
                              class="custom-checkbox"
                              name="manageGroupManagers"
                              v-model="createRole.canManageGroupManagers"
                            />
                            <label
                              class="font-normal text-[#353535] text-[16px] m-0 w-full"
                              for="manageGroupManagers"
                              >Manage Group Managers</label
                            >
                          </div>
                        </li>
                      </ol>
                    </li>

                    <li>
                      <div
                        class="flex items-center gap-[5px] py-[10px] px-[10px] border-b border-[#eee]"
                      >
                        <input
                          type="checkbox"
                          name="distributorManager"
                          class="custom-checkbox"
                          v-model="createRole.isDistributorManager"
                        />
                        <label
                          class="font-normal text-[#353535] text-[16px] m-0 w-full"
                          for="distributorManager"
                          >Distributor Manager</label
                        >
                      </div>
                    </li>
                    <li>
                      <div
                        class="flex items-center gap-[5px] py-[10px] px-[10px] border-b border-[#eee]"
                      >
                        <input
                          type="checkbox"
                          class="custom-checkbox"
                          name="stateManager"
                          v-model="createRole.isStateManager"
                        />
                        <label
                          class="font-normal text-[#353535] text-[16px] m-0 w-full"
                          for="stateManager"
                          >State Manager</label
                        >
                      </div>
                    </li>
                    <li>
                      <div
                        class="flex items-center gap-[5px] py-[10px] px-[10px] border-b border-[#eee]"
                      >
                        <input
                          type="checkbox"
                          name="groupManager"
                          class="custom-checkbox"
                          v-model="createRole.isGroupManager"
                        />
                        <label
                          class="font-medium text-[#353535] text-[16px] m-0 w-full"
                          for="groupManager"
                          >Group Manager</label
                        >
                      </div>
                    </li>
                  </ol>
                  <ol class="flex flex-col gap-[5px] w-full">
                    <li v-for="item in permissionsListCreate" :key="item.id">
                      <div
                        class="flex items-center justify-between gap-[5px] py-[14px] px-[10px] border-b border-[#eee] cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          :disabled="item.state.disabled"
                          :name="item.text"
                          :checked="item.state.selected"
                          class="custom-checkbox"
                          @click.stop="
                            item.state.selected = !item.state.selected
                          "
                          @change="
                            onPermissionChange(item, item.state.selected)
                          "
                        />
                        <label
                          :for="item.text"
                          class="font-normal text-[#353535] text-[16px] m-0 w-full"
                          >{{ item.text }}</label
                        >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6 text-[#353535] transition-transform duration-300 cursor-pointer"
                          :class="item.state.opened ? 'rotate-180' : 'rotate-0'"
                          @click="item.state.opened = !item.state.opened"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>

                      <ol v-if="item.children.length != 0 && item.state.opened">
                        <li
                          v-for="children in item.children"
                          :data-id="children.id"
                          class="border-b border-[#eee]w-full py-[11px]"
                          :key="children.id"
                        >
                          <div class="px-[28px] flex items-center gap-[8px]">
                            <input
                              type="checkbox"
                              :name="children.text"
                              :checked="children.state.selected"
                              :disabled="children.state.disabled"
                              class="custom-checkbox"
                              @click="
                                children.state.selected = !children.state
                                  .selected
                              "
                            />
                            <label
                              :for="children.text"
                              class="text-[#353535] font-normal text-[14px] m-0 w-full"
                              >{{ children.text }}</label
                            >
                          </div>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
                <ul v-if="v1.accessRights" class="parsley-errors-list filled">
                  <li class="parsley-required">
                    Please select at least one access right.
                  </li>
                </ul>
                <ul
                  v-if="v1.managerAccessRights"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">
                    Please select at least one access right for manager.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="w-full flex items-center gap-[8px] mt-[16px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none disabled:cursor-not-allowed"
              type="button"
              data-dismiss="modal"
              :disabled="isBusyModal"
              @click="reset"
            >
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none disabled:cursor-not-allowed"
              :disabled="isBusyModal"
              type="button"
              @click.prevent="create"
            >
              {{ isBusyModal ? "Loading..." : "Add Role" }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- editing sales roles -->
    <div class="modal fade" id="mod-edit-sales" role="dialog">
      <div
        class="modal-dialog p-0 m-0 fixed overflow-y-scroll top-0 right-0 flex justify-end items-end"
      >
        <div class="modal-content h-full rounded-none bg-[#f8f8f8] p-[40px]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4
              class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]"
            >
              Manage Sales Role
            </h4>
            <button
              class="text-2xl text-[#353535]"
              type="button"
              data-dismiss="modal"
              aria-hidden="true"
            >
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body p-0 m-0">
            <!-- {{ editRoles }} -->
            <div>
              <label
                class="text=[#353535] font-bold-500 text-[14px] leading-[20px]"
                >Role Name</label
              >
              <div class="mb-[16px] w-full">
                <input
                  :class="[{ 'is-invalid': v2.roleName }]"
                  type="text"
                  v-model="updateRole.roleName"
                  class="bg-[[#fcfcfd]] border-[##96a0b5] border-solid border-[1.5px] py-[14px] px-[16px] md:px-[24px] rounded-[8px] text-[14px] md:text-[16px] font-medium leading-[20px] w-full"
                  placeholder="Enter role name"
                />
                <ul v-if="v2.roleName" class="parsley-errors-list filled">
                  <li class="parsley-required">Required.</li>
                </ul>
              </div>
            </div>

            <div class="mt-[16px]">
              <div>
                <label
                  class="text-[#353535] font-medium text-[14px] leading-[20px]"
                  >Access Rights</label
                >
                <div
                  class="bg-white w-full"
                  style="height: 380px; overflow-y: scroll"
                >
                  <ol>
                    <li>
                      <div
                        class="flex items-center gap-[5px] py-[14px] px-[10px] border-b border-[#eee]"
                      >
                        <!-- {{ mdData(updateRole) }} -->
                        <input
                          type="checkbox"
                          name="manager"
                          class="custom-checkbox"
                          v-model="updateRole.isManager"
                          @click.stop
                        />
                        <label
                          class="font-normal text-[#353535] text-[16px] m-0 w-full"
                          for="manager"
                          >Manager</label
                        >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6 text-[#353535] transition-transform duration-300 cursor-pointer"
                          :class="{ 'rotate-180': isManagerDropdownOpen }"
                          @click="toggleManagerDropdown"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>

                      <ol v-show="isManagerDropdownOpen">
                        <li>
                          <div
                            class="flex items-center gap-[5px] py-[10px] px-[26px] border-b border-[#eee]"
                          >
                            <input
                              type="checkbox"
                              name="manageDistributorManagers"
                              class="custom-checkbox"
                              v-model="updateRole.canManageDistributorManagers"
                            />
                            <label
                              class="font-normal text-[#353535] text-[16px] m-0 w-full"
                              for="manageDistributorManagers"
                              >Manage Distributor Managers</label
                            >
                          </div>
                        </li>
                        <li>
                          <div
                            class="flex items-center gap-[5px] py-[10px] px-[26px] border-b border-[#eee]"
                          >
                            <input
                              type="checkbox"
                              name="manageStateManagers"
                              class="custom-checkbox"
                              v-model="updateRole.canManageStateManagers"
                            />
                            <label
                              class="font-normal text-[#353535] text-[16px] m-0 w-full"
                              for="manageStateManagers"
                              >Manage State Managers</label
                            >
                          </div>
                        </li>
                        <li>
                          <div
                            class="flex items-center gap-[5px] py-[10px] px-[26px] border-b border-[#eee]"
                          >
                            <input
                              type="checkbox"
                              name="manageGroupManagers"
                              class="custom-checkbox"
                              v-model="updateRole.canManageGroupManagers"
                            />
                            <label
                              class="font-normal text-[#353535] text-[16px] m-0 w-full"
                              for="manageGroupManagers"
                              >Manage Group Managers</label
                            >
                          </div>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <div
                        class="flex items-center gap-[5px] py-[10px] px-[10px] border-b border-[#eee]"
                      >
                        <input
                          type="checkbox"
                          name="distributorManager"
                          class="custom-checkbox"
                          v-model="updateRole.isDistributorManager"
                        />
                        <label
                          class="font-normal text-[#353535] text-[16px] m-0 w-full"
                          for="distributorManager"
                          ><b>Distributor Manager</b></label
                        >
                      </div>
                    </li>
                    <li>
                      <div
                        class="flex items-center gap-[5px] py-[10px] px-[10px] border-b border-[#eee]"
                      >
                        <input
                          type="checkbox"
                          name="stateManager"
                          class="custom-checkbox"
                          v-model="updateRole.isStateManager"
                        />
                        <label
                          class="font-normal text-[#353535] text-[16px] m-0 w-full"
                          for="stateManager"
                          >State Manager</label
                        >
                      </div>
                    </li>
                    <li>
                      <div
                        class="flex items-center gap-[5px] py-[10px] px-[10px] border-b border-[#eee]"
                      >
                        <input
                          type="checkbox"
                          name="groupManager"
                          class="custom-checkbox"
                          v-model="updateRole.isGroupManager"
                        />
                        <label
                          class="font-medium text-[#353535] text-[16px] m-0 w-full"
                          for="groupManager"
                          >Group Manager</label
                        >
                      </div>
                    </li>
                  </ol>
                  <ol class="flex flex-col gap-[5px] w-full">
                    <li v-for="item in permissionsListUpdate" :key="item.id">
                      <div
                        class="flex items-center justify-between gap-[5px] py-[14px] px-[10px] border-b border-[#eee] cursor-pointer"
                      >
                        <input
                          type="checkbox"
                          :disabled="item.state.disabled"
                          :name="item.text"
                          :checked="item.state.selected"
                          class="custom-checkbox"
                          @click.stop="
                            item.state.selected = !item.state.selected
                          "
                          @change="
                            onPermissionChange(item, item.state.selected)
                          "
                        />
                        <label
                          :for="item.text"
                          class="font-normal text-[#353535] text-[16px] m-0 w-full"
                          ><b>{{ item.text }}</b></label
                        >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-6 w-6 text-[#353535] transition-transform duration-300 cursor-pointer"
                          :class="item.state.opened ? 'rotate-180' : 'rotate-0'"
                          @click="item.state.opened = !item.state.opened"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </div>

                      <ol v-if="item.children.length != 0 && item.state.opened">
                        <li
                          v-for="children in item.children"
                          :data-id="children.id"
                          class="border-b border-[#eee]w-full py-[11px]"
                          :key="children.id"
                        >
                          <div class="px-[28px] flex items-center gap-[8px]">
                            <input
                              type="checkbox"
                              :name="children.text"
                              :checked="children.state.selected"
                              :disabled="children.state.disabled"
                              class="custom-checkbox"
                              @click="
                                children.state.selected = !children.state
                                  .selected
                              "
                            />
                            <label
                              :for="children.text"
                              class="text-[#353535] font-normal text-[14px] m-0 w-full"
                              >{{ children.text }}</label
                            >
                          </div>
                        </li>
                      </ol>
                    </li>
                  </ol>
                </div>
                <ul v-if="v2.accessRights" class="parsley-errors-list filled">
                  <li class="parsley-required">
                    Please select at least one access right.
                  </li>
                </ul>
                <ul
                  v-if="v2.managerAccessRights"
                  class="parsley-errors-list filled"
                >
                  <li class="parsley-required">
                    Please select at least one access right for manager.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="w-full flex items-center gap-[8px] mt-[16px]">
            <button
              class="bg-[#fcfcfd] border-[##96a0b5] border-solid border py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none disabled:cursor-not-allowed"
              type="button"
              data-dismiss="modal"
              @click="cancel"
              :disabled="isBusyModal"
            >
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none disabled:cursor-not-allowed"
              :disabled="isBusyModal"
              type="button"
              @click.prevent="update"
            >
              {{ isBusyModal ? "Loading..." : "Update" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import moment from "moment";
import { helper } from "@/helper";
import Select2 from "@/components/Select2";
import SystemPermissions from "@/permissions";
import Pagination from "../Pagination.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  name: "salesRole",
  props: ["editRoles", "salesEdit"],
  components: {
    Select2,
    Pagination,
  },

  watch: {
    "createRole.isManager": function(newType, oldType) {
      if (newType == false) {
        this.createRole.canManageDistributorManagers = newType;
        this.createRole.canManageStateManagers = newType;
        this.createRole.canManageGroupManagers = newType;
      }
    },
    "updateRole.isManager": function(newType, oldType) {
      if (newType == false) {
        this.updateRole.canManageDistributorManagers = newType;
        this.updateRole.canManageStateManagers = newType;
        this.updateRole.canManageGroupManagers = newType;
      }
    },
    "createRole.canManageDistributorManagers": function(newType, oldType) {
      if (newType == true) this.createRole.isManager = newType;
      else {
        if (
          !this.createRole.canManageGroupManagers &&
          !this.createRole.canManageStateManagers
        )
          this.createRole.isManager = false;
      }
    },
    "createRole.canManageStateManagers": function(newType, oldType) {
      if (newType == true) this.createRole.isManager = newType;
      else {
        if (
          !this.createRole.canManageGroupManagers &&
          !this.createRole.canManageDistributorManagers
        )
          this.createRole.isManager = false;
      }
    },
    "createRole.canManageGroupManagers": function(newType, oldType) {
      if (newType == true) this.createRole.isManager = newType;
      else {
        if (
          !this.createRole.canManageStateManagers &&
          !this.createRole.canManageDistributorManagers
        )
          this.createRole.isManager = false;
      }
    },
    "updateRole.canManageDistributorManagers": function(newType, oldType) {
      if (newType == true) this.updateRole.isManager = newType;
      else {
        if (
          !this.updateRole.canManageGroupManagers &&
          !this.updateRole.canManageStateManagers
        )
          this.updateRole.isManager = false;
      }
    },
    "updateRole.canManageStateManagers": function(newType, oldType) {
      if (newType == true) this.updateRole.isManager = newType;
      else {
        if (
          !this.updateRole.canManageGroupManagers &&
          !this.updateRole.canManageDistributorManagers
        )
          this.updateRole.isManager = false;
      }
    },
    "updateRole.canManageGroupManagers": function(newType, oldType) {
      if (newType == true) this.updateRole.isManager = newType;
      else {
        if (
          !this.updateRole.canManageStateManagers &&
          !this.updateRole.canManageDistributorManagers
        )
          this.updateRole.isManager = false;
      }
    },
  },

  data() {
    return {
      filter: {
        status: "0",
        qry: "",
      },
      isBusy: false,
      isBusyModal: false,
      isManagerDropdownOpen: true,
      createRole: {
        name: null,
        isManager: false,
        canManageDistributorManagers: false,
        canManageGroupManagers: false,
        canManageStateManagers: false,
        isDistributorManager: false,
        isStateManager: false,
        isGroupManager: false,
        permissions: [],
      },
      pageSize: 10,
      page: 0,
      updateRole: {
        name: null,
        id: null,
        isManager: false,
        canManageDistributorManagers: false,
        canManageGroupManagers: false,
        canManageStateManagers: false,
        isDistributorManager: false,
        isStateManager: false,
        isGroupManager: false,
        permissions: [],
      },
      editRole: {
        name: null,
        id: null,
        isManager: false,
        canManageDistributorManagers: false,
        canManageGroupManagers: false,
        canManageStateManagers: false,
        isDistributorManager: false,
        isStateManager: false,
        isGroupManager: false,
        permissions: null,
      },
      v1: {
        roleName: false,
        accessRights: false,
        managerAccessRights: false,
      },
      v2: {
        roleName: false,
        accessRights: false,
        managerAccessRights: false,
      },
      roles: [],
      permissions: [],
      assignments: [],
    };
  },
  computed: {
    user: function() {
      return this.$store.state.currentUser;
    },
    permissionsListCreate() {
      if (!this.createRole.permissions) {
        return [];
      }
      return this.createRole.permissions.map((b) => {
        return b;
      });
    },
    permissionsListUpdate() {
      if (!this.editRoles.permissions) {
        return [];
      }

      this.updateRole = this.editRoles;
      return this.editRoles.permissions.map((b) => {
        return b;
      });
    },
  },
  methods: {
    mdData(d) {
      if (d.id) {
        let m = d;
        // delete m["permissions"];
        return m;
      }
      return {};
    },
    toggleManagerDropdown() {
      this.isManagerDropdownOpen = !this.isManagerDropdownOpen;
    },
    onPermissionChange(item, state) {
      for (let child of item.children) {
        child.state.selected = state;
      }
    },
    reset() {
      this.filter = {
        status: "0",
        qry: "",
      };
    },
    cancel() {
      // const currentRole = this.Roles.find((l) => l.id === this.editRole.id);
      // currentRole.name = this.editRole.name;
      // currentRole.id = this.editRole.id;
      $("#mod-edit").modal("hide");
    },
    viewRoleUsers(r) {
      this.$router.push(
        "/sales-force/sales-roles/" + r.id + "/users?n=" + r.roleName
      );
    },
    viewExport() {
      //   $("#mod-export").modal("show");
    },
    viewAdd() {
      this.createRole = {
        name: null,
        isManager: false,
        canManageDistributorManagers: false,
        canManageGroupManagers: false,
        canManageStateManagers: false,
        isDistributorManager: false,
        isStateManager: false,
        isGroupManager: false,
        permissions: JSON.parse(JSON.stringify(this.permissions)),
      };
      this.v1 = {
        name: false,
        accessRights: false,
      };
      $("#mod-add").modal("show");
    },
    viewEdit(c) {
      var editValues = {
        name: c.roleName,
        id: c.id,
        isManager:
          c.canManageDistributorManagers ||
          c.canManageGroupManagers ||
          c.canManageStateManagers,
        canManageDistributorManagers: c.canManageDistributorManagers,
        canManageGroupManagers: c.canManageGroupManagers,
        canManageStateManagers: c.canManageStateManagers,
        isDistributorManager: c.isDistributorManager,
        isStateManager: c.isStateManager,
        isGroupManager: c.isGroupManager,
        permissions: JSON.parse(JSON.stringify(c.permissions)),
      };
      this.editRole = editValues;
      //this.updateRole = c;
      this.updateRole = {
        id: c.id,
        name: c.roleName,
        isManager:
          c.canManageDistributorManagers ||
          c.canManageGroupManagers ||
          c.canManageStateManagers,
        canManageDistributorManagers: c.canManageDistributorManagers,
        canManageGroupManagers: c.canManageGroupManagers,
        canManageStateManagers: c.canManageStateManagers,
        isDistributorManager: c.isDistributorManager,
        isStateManager: c.isStateManager,
        isGroupManager: c.isGroupManager,
        permissions: JSON.parse(JSON.stringify(c.permissions)),
      };

      $("#mod-edit").modal("show");
    },
    viewFilter() {
      $("#mod-filter").modal("show");
    },
    async deleteRole(c) {
      if (c.numberOfAssignedUsers > 0) {
        alert(
          "This role is currently in use by " +
            c.numberOfAssignedUsers +
            " user(s) and cannot be deleted. Please remove all users and then delete"
        );
        return;
      }
      if (confirm("Are you sure you want to delete this role?")) {
        this.isBusyModal = true;
        this.isBusy = true;

        await this.$http
          .post("/SalesRoles/delete/" + c.id, null)
          .then(function(res) {
            this.isBusyModal = false;
          })
          .catch(function() {});

        this.getRoles();

        this.isBusy = false;
      }
    },
    async create() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        name: this.createRole.name,
        parentId: this.user.parentId,
        canManageDistributorManagers: this.createRole
          .canManageDistributorManagers,
        canManageGroupManagers: this.createRole.canManageGroupManagers,
        canManageStateManagers: this.createRole.canManageStateManagers,
        isDistributorManager: this.createRole.isDistributorManager,
        isStateManager: this.createRole.isStateManager,
        isGroupManager: this.createRole.isGroupManager,
        permissions: this.createRole.permissions,
      };

      if (this.validateCreate()) {
        $("#mod-add").modal("hide");

        await this.$http
          .post("/SalesRoles/create", data)
          .then(function(res) {
            this.isBusyModal = false;
            this.$toast.success("Sales roles created successfully.", {
              icon: true,
              rtl: false,
            });

            this.$emit("salesRoleCompleted");
          })
          .catch(function() {});
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },
    validateCreate() {
      this.v1 = {
        name: false,
        accessRights: false,
        managerAccessRights: false,
      };
      var isValid = true;

      if (!this.createRole.name) {
        this.v1.name = true;
        isValid = false;
      }

      if (
        this.createRole.isManager &&
        !this.createRole.canManageDistributorManagers &&
        !this.createRole.canManageGroupManagers &&
        !this.createRole.canManageStateManagers
      ) {
        this.v1.managerAccessRights = true;
        isValid = false;
      }

      if (
        !this.createRole.canManageDistributorManagers &&
        !this.createRole.canManageGroupManagers &&
        !this.createRole.canManageStateManagers &&
        !this.createRole.isDistributorManager &&
        !this.createRole.isStateManager &&
        !this.createRole.isGroupManager
      ) {
        this.v1.accessRights = true;
        isValid = false;
      }

      return isValid;
    },
    async update() {
      this.isBusyModal = true;
      this.isBusy = true;

      var data = {
        name: this.updateRole.roleName,
        canManageDistributorManagers: this.updateRole
          .canManageDistributorManagers,
        canManageGroupManagers: this.updateRole.canManageGroupManagers,
        canManageStateManagers: this.updateRole.canManageStateManagers,
        isDistributorManager: this.updateRole.isDistributorManager,
        isStateManager: this.updateRole.isStateManager,
        isGroupManager: this.updateRole.isGroupManager,
        roleId: this.updateRole.id,
        parentId: this.user.parentId,
        permissions: this.updateRole.permissions,
      };

      if (this.validateUpdate()) {
        $("#mod-edit").modal("hide");

        await this.$http
          .put("/SalesRoles/update/" + data.roleId, data)
          .then(function(res) {
            this.isBusyModal = false;
            this.$toast.success("Sales roles Updated successfully.", {
              icon: true,
              rtl: false,
            });
            this.$emit("EditComplete");
          })
          .catch(function() {});
      }

      this.isBusy = false;
      this.isBusyModal = false;
    },
    validateUpdate() {
      this.v2 = {
        roleName: false,
        accessRights: false,
        managerAccessRights: false,
      };
      var isValid = true;

      if (!this.updateRole.roleName) {
        this.v2.roleName = true;
        isValid = false;
      }

      if (
        this.updateRole.isManager &&
        !this.updateRole.canManageDistributorManagers &&
        !this.updateRole.canManageGroupManagers &&
        !this.updateRole.canManageStateManagers
      ) {
        this.v2.managerAccessRights = true;
        isValid = false;
      }

      if (
        !this.updateRole.canManageDistributorManagers &&
        !this.updateRole.canManageGroupManagers &&
        !this.updateRole.canManageStateManagers &&
        !this.updateRole.isDistributorManager &&
        !this.updateRole.isStateManager &&
        !this.updateRole.isGroupManager
      ) {
        this.v2.accessRights = true;
        isValid = false;
      }

      return isValid;
    },
    async getRoles() {
      this.isBusy = true;

      await this.$http
        .get(
          "/SalesRoles/getRoleList?page=" +
            this.page +
            "&pageSize=" +
            this.pageSize +
            (this.user.parentId ? "&parentId=" + this.user.parentId : "") +
            (this.filter.status != "0" ? "&active=" + this.filter.status : "") +
            (this.filter.qry != "" ? "&query=" + this.filter.qry : "")
        )
        .then(function(res) {
          this.roles = res.body.data;
          this.page = res.body.page;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.isBusy = false;
        })
        .catch(function() {});

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },
    async getPermissions() {
      this.isBusy = true;

      await this.$http
        .get("/Roles/getPermissionList?roleType=sales")
        .then(function(res) {
          this.permissions = res.body;
          this.createRole.permissions = this.permissions;
          this.page = res.body.page;
          this.pageSize = res.body.pageSize;
          this.count = res.body.count;
          this.pageCount = Math.ceil(res.body.count / res.body.pageSize);
          this.hasPrev = res.body.hasPrev;
          this.hasNext = res.body.hasNext;
          this.isBusy = false;
        })
        .catch(function() {});

      $("#mod-filter").modal("hide");
      this.isBusy = false;
    },

    formatDate(date) {
      return moment(date).format("lll");
    },
    formatMoney(val) {
      return helper.formatMoney(val);
    },
    prev() {
      this.page -= 1;
      this.getRoles();
    },
    next() {
      this.page += 1;
      this.getRoles();
    },

    gotoPage(page) {
      this.page = page;
      this.getRoles();
    },

    changeLimit(limit) {
      this.pageSize = limit;
      this.getRoles();
    },
  },
  mounted() {
    this.getPermissions();
    // this.getAssignments();
  },
};
</script>
<style scoped>
.custom-checkbox {
  width: 24px;
  height: 18.9px;
  appearance: none;
  border: 1px solid #96a0b5;
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  outline: none;
  transition: background-color 0.2s ease-in-out;
}
.custom-checkbox:checked {
  background-color: rgba(36, 99, 235, 0.5);
  border-color: rgba(36, 99, 235, 1);
}

.custom-checkbox:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #2463eb;
  font-size: 14px;
}
</style>
